import PropTypes from 'prop-types';
import { Modal } from 'antd';

const ModalWrapper = (props) => {
  const {
    title = '',
    showModal,
    onHide,
    children,
    width,
    gutter,
    footer,
    className,
    closable = true,
    zIndex,
    maxBodyHeight,
    isScrollbar,
    maskClosable = false,
  } = props;
  return (
    <>
      <Modal
        open={showModal}
        title={title}
        width={width}
        onCancel={onHide}
        keyboard={false}
        bodyStyle={{
          padding: gutter,
          maxHeight: `${maxBodyHeight}px`,
          overflowY: isScrollbar ? 'auto' : 'inherit',
        }}
        footer={footer}
        className={`${className} ${closable && 'close_enabled'}`}
        closable={closable}
        zIndex={zIndex}
        maskClosable={maskClosable}
      >
        {children}
      </Modal>
    </>
  );
};

ModalWrapper.propTypes = {
  title: PropTypes.any,
  showModal: PropTypes.bool,
  onHide: PropTypes.func,
  children: PropTypes.any,
  width: PropTypes.any,
  gutter: PropTypes.string,
  footer: PropTypes.any,
  className: PropTypes.string,
  closable: PropTypes.bool,
  zIndex: PropTypes.string,
  maxBodyHeight: PropTypes.string,
  isScrollbar: PropTypes.bool,
  maskClosable: PropTypes.bool,
};

export default ModalWrapper;
